import React, { Component } from 'react'

class Redirection extends Component {
       
    render() {
        return (
            <a href={this.props.data.value} className="btn btn-default"><span>{this.props.data.label} <i className="fa fa-chevron-right" aria-hidden="true"></i></span></a>
        )
        
    }
}

export default Redirection


// WEBPACK FOOTER //
// ./src/Redirection.js